export default {"src":"/_next/static/media/eye-outline.5d06580a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};